@use "Styles/mixins";

:host {
    display: inline-block;
    box-sizing: border-box;
    flex-shrink: 0;
    vertical-align: top;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}

.vm-image-thumbnail {
    display: block;
    width: var(--vm-image-thumbnail-size, 75px);
    height: var(--vm-image-thumbnail-size, 75px);
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: var(--vm-image-thumbnail-radius, 4px);
    overflow: hidden;

    &__image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        background: mixins.get-color(background, bg-gray-50);
    }
}
